import React, { useEffect, useState } from 'react';
import useOrderPackages from 'hooks/useOrderPackages';
import { downloadPDF } from 'utils/downloadPDF';
import useCustomSnackbar from 'hooks/useCustomSnackbar';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Close from '@material-ui/icons/Close';
import useStyles from './OrderPackageList.styles';
import { useOrdersContext } from 'contextApi/OrdersContext';
import OrderPackageForm from 'components/organisms/OrderPackageForm';
import {
  Typography,
  Button,
  Grid,
  Table,
  TableBody,
  Paper,
  Box,
  Collapse,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  CircularProgress,
  TextField
} from '@material-ui/core';
import MovePorduct from '../MoveProductModal';
import { IOrderProducts, IOrderShippingRequest, IPackages } from 'interfaces/orderPackages.interface';

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset'
    }
  }
});

interface Props {
  shippingType: string | undefined;
  dropshipper: string | undefined;
}

export default function OrderPackageList({ shippingType, dropshipper }: Props) {
  const { orderPackages, orderPackageShipping, setOrderPackages, handleOpenModalCreateShipping } = useOrdersContext();
  const { createPackage, getOrderPackages, createPackageDelivery } = useOrderPackages();
  const { showNotistack } = useCustomSnackbar();
  const [newPackSourceModal, setNewPackSource] = useState<IPackages>({
    id: 0,
    type: 'b',
    height: 0,
    width: 0,
    length: 0,
    weight: 0
  });
  const [newPackDestinationModal, setNewPackDestination] = useState<IPackages>({
    id: 0,
    type: 'b',
    height: 0,
    width: 0,
    length: 0,
    weight: 0
  });
  const [sourceModal, setSource] = useState<any>();
  const [destinationModal, setDestination] = useState<any>();
  const [productMoved, setProductMoved] = useState<IOrderProducts>({});
  const [openMoveProductModal, setOpenMoveProductModal] = useState(false);
  const [countSelectedPackages, setCountSelectedPackges] = useState<number>(0);
  const [open, setOpen] = React.useState<boolean[]>([]);
  const classes = useRowStyles();
  const styles = useStyles();
  const [isLoading, setIsLoading] = useState(false);

  const displayTables = () => {
    const quantityPackage = orderPackages.packages?.length;
    if (quantityPackage) {
      for (let i = 0; i < quantityPackage; i++) {
        setOpen((prevState: any) => [...prevState, false]);
      }
    }
  };

  const addPackage = () => {
    if (orderPackages.packages) {
      const lengthPackage = orderPackages.packages?.length - 1;

      const sumId = orderPackages.packages[lengthPackage].id + 1;
      const newPackage: IPackages = {
        id: sumId,
        type: 'B',
        height: 35,
        width: 35,
        length: 23,
        weight: 7,
        products: []
      };

      setOrderPackages({
        packages: [...orderPackages.packages, newPackage]
      });
    }
  };

  useEffect(() => {
    displayTables();
  }, []);

  const reorder = (list: any, startIndex: number, endIndex: number) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const handleOnSubmit = () => {
    setIsLoading(true);
    let specifyPackage: IPackages[];
    let arrayPackage: IOrderShippingRequest = {};
    if (!orderPackageShipping.labelId || !orderPackageShipping.warehouseId) {
      showNotistack({ message: 'Todos los campos son obligatorios' });
      setIsLoading(false);
      return;
    }
    if (shippingType === '2') {
      if (orderPackages.packages) {
        if (orderPackageShipping.packages) {
          specifyPackage = orderPackages.packages.filter((packageDetails) => packageDetails.isToSend === true);
          orderPackageShipping.packages = specifyPackage;
          arrayPackage = orderPackageShipping;

          createPackage(arrayPackage)
            .then((response) => {
              getOrderPackages(orderPackageShipping.orderId).then((orderPackages) => {
                setOrderPackages(orderPackages);
                if (orderPackages.packages && orderPackages.packages?.length < 1) {
                  handleOpenModalCreateShipping(false);
                }
              });
              downloadPDF(response.pdf, `pedido_${orderPackageShipping.orderId}_guia_${response.trackingId}`);
              setCountSelectedPackges(0);
            })
            .catch((err) => {
              if (err.response?.status === 400 && err.response.data?.message) {
                showNotistack({ message: err.response.data?.message });
              } else {
                showNotistack({
                  message: typeof err === 'string' ? err : 'Ocurrió un error, contacta con soporte por favor.'
                });
              }
            })
            .finally(() => {
              setIsLoading(false);
            });
        }
      }
    } else {
      if (orderPackages.packages) {
        if (orderPackageShipping.packages) {
          specifyPackage = orderPackages.packages.filter((packageDetails) => packageDetails.isToSend === true);
          orderPackageShipping.packages = specifyPackage;
          arrayPackage = orderPackageShipping;

          createPackageDelivery(arrayPackage)
            .then((response) => {
              getOrderPackages(orderPackageShipping.orderId).then((orderPackages) => {
                setOrderPackages(orderPackages);

                if (orderPackages.packages && orderPackages.packages?.length < 1) {
                  handleOpenModalCreateShipping(false);
                }
              });
              downloadPDF(response.pdf, `pedido_${orderPackageShipping.orderId}_guia_${response.trackingId}`);
              setCountSelectedPackges(0);
            })
            .catch((err) => {
              if (err.response?.status === 400 && err.response.data?.message) {
                showNotistack({ message: err.response.data?.message });
              } else {
                showNotistack({
                  message: typeof err === 'string' ? err : 'Ocurrió un error, contacta con soporte por favor.'
                });
              }
            })
            .finally(() => {
              setIsLoading(false);
            });
        }
      }
    }
  };

  const onDragEnd = (result: any) => {
    // dropped outside the list

    const { source, destination } = result;
    if (!destination) {
      return;
    }

    if (orderPackages.packages !== undefined) {
      if (source.droppableId === destination.droppableId) {
        const newPackage: any = orderPackages.packages.find(
          (packageDetail: IPackages) => packageDetail.id === Number(source.droppableId)
        );

        const newPackIndex = orderPackages.packages.findIndex((t: any) => t.id === source.droppableId);

        newPackage.products = reorder(newPackage.products, source.index, destination.index);
        orderPackages.packages[newPackIndex] = newPackage;

        const itemsD = {
          orderNumber: orderPackages.orderNumber,
          packages: orderPackages.packages
        };
        setOrderPackages(itemsD);
      } else {
        const newPackSource = orderPackages.packages.find(
          (packageSource: IPackages) => packageSource.id === Number(source.droppableId)
        );

        const newPackDestination = orderPackages.packages.find(
          (packageDestination: IPackages) => packageDestination.id === Number(destination.droppableId)
        );

        if (newPackDestination?.trackingNumber) {
          return;
        }

        if (newPackSource?.products && newPackDestination) {
          const sourceClone = Array.from(newPackSource.products);
          const [removed] = sourceClone.splice(source.index, 1);
          setProductMoved(removed);
          setNewPackSource(newPackSource);
          setNewPackDestination(newPackDestination);
          setSource(source);
          setDestination(destination);
          setOpenMoveProductModal(true);
        }
      }
    }
  };

  const getListStyle = (isDraggingOver: boolean) => ({
    background: isDraggingOver ? 'lightblue' : 'white',
    padding: '15px',
    width: '100%'
  });

  const handleCloseMoveProductModal = () => {
    setOpenMoveProductModal(false);
    console.log('array', orderPackages);
    //handleGetOrders();
  };

  const getTrackingNumbersChips = (
    trackingNumbers: string | string[] | undefined,
    trackingUrls: string | string[] | undefined
  ): JSX.Element[] => {
    if (trackingNumbers && Array.isArray(trackingNumbers)) {
      if (trackingNumbers.length === 0) {
        return [<Chip variant="outlined" size="small" color="primary" label="No enviado" clickable key="1asa" />];
      }
      return trackingNumbers.map((t, index) => (
        <Chip
          variant="outlined"
          size="small"
          color="primary"
          label={`${t}`}
          clickable
          onClick={() => {
            if (trackingUrls) {
              window.open(`${Array.isArray(trackingUrls) ? trackingUrls[index] : trackingUrls}`);
            }
          }}
          key={index}
        />
      ));
    } else if (trackingNumbers && typeof trackingNumbers === 'string') {
      return [
        <Chip
          variant="outlined"
          size="small"
          color="primary"
          label={`${trackingNumbers}`}
          clickable
          onClick={() => {
            window.open(`${trackingUrls}`);
          }}
          key="324fd"
        />
      ];
    } else {
      return [<Chip variant="outlined" size="small" color="primary" label="No enviado" clickable key="324sdfafd" />];
    }
  };

  return (
    <TableContainer component={Paper} className={styles.tableContainer}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell colSpan={4}>Paquetes</TableCell>
            <TableCell>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  addPackage();
                }}
              >
                +
              </Button>
            </TableCell>
            {countSelectedPackages > 1 ? (
              <React.Fragment>
                <TableCell>
                  <Button
                    disabled={isLoading}
                    type="submit"
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                      handleOnSubmit();
                    }}
                  >
                    {isLoading ? <CircularProgress size={24} /> : ''} Consolidar
                  </Button>
                </TableCell>
              </React.Fragment>
            ) : null}
          </TableRow>
        </TableHead>
        <TableBody>
          <DragDropContext onDragEnd={onDragEnd}>
            {orderPackages.packages !== undefined
              ? orderPackages.packages.map((orderPackageDetail: IPackages, index: number) => (
                  <Droppable droppableId={String(orderPackageDetail.id)} key={index}>
                    {(provided, snapshot) => (
                      <React.Fragment>
                        <TableRow className={classes.root} key={orderPackageDetail.id}>
                          <TableCell className={styles.colorColumn}>
                            <Checkbox
                              color="primary"
                              disabled={orderPackageDetail.status}
                              checked={orderPackageDetail.status ? true : undefined}
                              inputProps={{ 'aria-label': 'secondary checkbox' }}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  orderPackageDetail.isToSend = true;
                                  setCountSelectedPackges(countSelectedPackages + 1);
                                } else {
                                  orderPackageDetail.isToSend = false;
                                  setCountSelectedPackges(countSelectedPackages - 1);
                                }
                              }}
                            />
                            <IconButton
                              aria-label="expand row"
                              size="small"
                              onClick={() => {
                                const openCopy = [...open];
                                if (openCopy[index]) {
                                  openCopy[index] = false;
                                } else {
                                  openCopy[index] = true;
                                }
                                setOpen(openCopy);
                              }}
                            >
                              {open[index] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                            Paquete {orderPackageDetail.type}
                          </TableCell>
                          <OrderPackageForm
                            orderPackageDetail={orderPackageDetail}
                            index={index}
                            shippingType={shippingType}
                          />
                        </TableRow>
                        <TableRow>
                          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                            <Grid
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                              style={getListStyle(snapshot.isDraggingOver)}
                            >
                              <Collapse in={open[index]} timeout="auto" unmountOnExit>
                                <Box margin={1}>
                                  <Typography variant="h6" gutterBottom component="div">
                                    Productos
                                  </Typography>
                                  <Table size="small" aria-label="purchases" className={styles.tableContainer}>
                                    <TableHead>
                                      <TableRow>
                                        <TableCell>SKU</TableCell>
                                        <TableCell>Nombre</TableCell>
                                        <TableCell align="right">Cantidad</TableCell>
                                        <TableCell align="right">Enviar</TableCell>
                                        {dropshipper === 'dco' && <TableCell align="right">Stock</TableCell>}
                                        <TableCell align="right"># Guía</TableCell>
                                        <TableCell align="right"></TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {orderPackageDetail && orderPackageDetail.products !== undefined
                                        ? orderPackageDetail.products.map(
                                            (productInfo: IOrderProducts, indexP: number) => (
                                              <Draggable
                                                key={indexP}
                                                draggableId={String(productInfo.id) + index}
                                                index={indexP}
                                              >
                                                {(provided) => (
                                                  <TableRow
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    key={productInfo.id}
                                                  >
                                                    <TableCell>{productInfo.sku}</TableCell>
                                                    <TableCell>{productInfo.name}</TableCell>
                                                    <TableCell align="right">{productInfo.quantity}</TableCell>
                                                    <TableCell align="right">
                                                      {!orderPackageDetail.trackingNumber && (
                                                        <TextField
                                                          type="number"
                                                          value={Number(productInfo.quantityToSend)}
                                                          InputProps={{
                                                            inputProps: { max: productInfo.quantity, min: 1 }
                                                          }}
                                                          onChange={(e) => {
                                                            const quantityToSend = Number(e.target.value);
                                                            if (
                                                              quantityToSend > Number(productInfo.quantity) ||
                                                              quantityToSend < 1
                                                            ) {
                                                              return;
                                                            }
                                                            if (orderPackages.packages) {
                                                              const orderPackageCopy = [...orderPackages.packages];
                                                              const products = orderPackageCopy[index].products;
                                                              if (products) {
                                                                products[indexP].quantityToSend = quantityToSend;
                                                              }

                                                              setOrderPackages({
                                                                ...orderPackages,
                                                                packages: orderPackageCopy
                                                              });
                                                            }
                                                          }}
                                                        />
                                                      )}
                                                    </TableCell>
                                                    {dropshipper === 'dco' && (
                                                      <TableCell align="right">{productInfo.stock_quantity}</TableCell>
                                                    )}
                                                    <TableCell align="right">
                                                      {getTrackingNumbersChips(
                                                        productInfo.trackingNumbers,
                                                        productInfo.trackingUrls
                                                      )}
                                                    </TableCell>
                                                    <TableCell style={{ cursor: 'pointer', color: 'red' }}>
                                                      {productInfo.quantity === 0 && (
                                                        <Close
                                                          onClick={() => {
                                                            const packagesEdited = orderPackages.packages;
                                                            if (packagesEdited && packagesEdited.length > 0) {
                                                              const ordD = packagesEdited[index];
                                                              if (ordD.products && ordD.products.length > 0) {
                                                                ordD.products.splice(indexP, 1);
                                                                packagesEdited[index] = ordD;
                                                              }

                                                              setOrderPackages((current) => {
                                                                return {
                                                                  ...current,
                                                                  packages: packagesEdited
                                                                };
                                                              });
                                                            }
                                                          }}
                                                        />
                                                      )}
                                                    </TableCell>
                                                  </TableRow>
                                                )}
                                              </Draggable>
                                            )
                                          )
                                        : null}
                                    </TableBody>
                                  </Table>
                                </Box>
                              </Collapse>
                              {provided.placeholder}
                            </Grid>
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    )}
                  </Droppable>
                ))
              : null}
          </DragDropContext>
        </TableBody>
      </Table>
      <MovePorduct
        open={openMoveProductModal}
        close={handleCloseMoveProductModal}
        productInfo={productMoved}
        newPackSource={newPackSourceModal}
        newPackDestination={newPackDestinationModal}
        source={sourceModal}
        destination={destinationModal}
      />
    </TableContainer>
  );
}
